// libraries
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueDraggable from 'vuedraggable';
import moment from 'moment';
import Axios from 'axios';
import DOMPurify from 'dompurify';
import 'element-scroll-polyfill';
// config
import AppConfig from './env.js';
// core
import App from './components/views/App';
import router from './router';
import store from './store/index';
// common
import Btn from './components/common/Btn';
import Counter from './components/common/Counter';
import Field from './components/common/Field';
import Icon from './components/common/Icon';
import InfoBox from './components/common/InfoBox';
import LanguageSwitcher from './components/common/LanguageSwitcher';
import Switcher from './components/common/Switcher';
import Message from './components/common/Message';
import SanitizeUtils from './components/helpers/SanitizeUtils';
import Translations from './langs/loader.js';

// DOMPurify configuration
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    if (!(node.getAttribute('href') && node.getAttribute('href').indexOf('/') === 0)) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  }

  // set non-HTML/MathML links to xlink:show=new
  if (!node.hasAttribute('target') && (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
    node.setAttribute('xlink:show', 'new');
  }
});

// Additional configuration
Vue.config.productionTip = false;

// Add global Vue properties for commonly used libraries and variables
Vue.prototype.$moment = moment;
Vue.prototype.$moment.locale(AppConfig.uiLanguage);
Vue.prototype.$window = window;
Vue.prototype.$allowedImageFiles = '.jpg,.jpeg,.png,.webp';

// Add global Vue property with local app configuration
Vue.prototype.$config = AppConfig;
Vue.prototype.$http = Axios;
Vue.prototype.$http.defaults.baseURL = AppConfig.apiServerUrl;
// eslint-disable-next-line
Vue.prototype.$favicon = new Favico({
  animation: 'none',
  type: 'rectangle'
});

if (SanitizeUtils.getToken()) {
  Vue.prototype.$http.defaults.headers['Authorization'] = 'Bearer ' + SanitizeUtils.getToken();
  Vue.prototype.$http.defaults.headers['Cache-Control'] = 'no-store,max-age=0';
}

// Add use of additional libraries
Vue.use(VueI18n);

// Declare event bus
Vue.prototype.$bus = new Vue();

// Register global components
Vue.component('btn', Btn);
Vue.component('counter', Counter);
Vue.component('field', Field);
Vue.component('icon', Icon);
Vue.component('info-box', InfoBox);
Vue.component('language-switcher', LanguageSwitcher);
Vue.component('message', Message);
Vue.component('switcher', Switcher);
Vue.component('draggable', VueDraggable);

const DOMPurifyConfig = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling']
};

// Register v-pure-html directive
Vue.directive('pure-html', {
  inserted: function (el, binding) {
    if (binding.oldValue === binding.value) {
      return;
    }
    el.innerHTML = DOMPurify.sanitize(binding.value, DOMPurifyConfig).replace(/<iframe/gmi, '<bookero-iframe').replace(/<\/iframe/gmi, '</bookero-iframe');
  },
  update: function (el, binding) {
    if (binding.oldValue === binding.value) {
      return;
    }
    el.innerHTML = DOMPurify.sanitize(binding.value, DOMPurifyConfig).replace(/<iframe/gmi, '<bookero-iframe').replace(/<\/iframe/gmi, '</bookero-iframe');
  }
});

// Configure languages
const i18n = new VueI18n({
  locale: AppConfig.uiLanguage,
  messages: Translations,
  pluralizationRules: {
    'pl': function (choice) {
      if (choice === 0) {
        return 0;
      }

      if (choice === 1) {
        return 1;
      }

      if (choice % 100 > 10 && choice % 100 < 20) {
        return 3;
      }

      if (choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return 3;
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App),
  components: {
    'App': App
  },
  data () {
    return {
      defaultCurrency: '',
      renewCurrency: '',
      formReferrer: ''
    };
  },
  mounted () {
    document.title = this.$t('app.pageTitle');
    // Security notice for users
    console.log('%c⚠️ OSTRZEŻENIE! ⚠️', 'background: red; color: yellow; font-size: 30px; padding: 10px; font-weight: bold;');
    console.log('%cKorzystanie z tej konsoli może umożliwić hakerom podszywanie się pod Ciebie oraz kradzież danych Twoich lub Twoich klientów poprzez atak zwany Self-XSS.', 'font-size: 20px;');
    console.log('%cNie wpisuj oraz nie wklejaj kodu, którego działania nie rozumiesz.', 'font-size: 16px; color: red;');
  }
});



// WEBPACK FOOTER //
// ./src/main.js